import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type Forward10IconProps = IconProps;

export const Forward10Icon = forwardRef<SVGSVGElement, Forward10IconProps>(
  function Forward10Icon(props: Forward10IconProps, ref) {
    return (
      <Icon
        data-testid="Forward10Icon"
        aria-label="forward 10"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M4.021 2C1.772 2-.04 3.835.001 6.071.04 8.252 1.829 10 4.021 10H8v2l4-2.5L8 7v2H4.021a3.008 3.008 0 0 1-3.015-2.946A3.008 3.008 0 0 1 4.021 3V2z" />
        <path d="M7.295 5.25h-.807V2.034l.003-.321.007-.314c.005-.103.01-.201.017-.294a2.318 2.318 0 0 1-.178.171 7.906 7.906 0 0 1-.219.191l-.574.458-.403-.509L6.624.254h.67v4.997zm4.528-2.502c0 .403-.032.764-.096 1.083-.062.317-.16.586-.294.807s-.31.39-.526.506a1.644 1.644 0 0 1-.786.174c-.385 0-.703-.101-.954-.304-.251-.205-.436-.499-.557-.882-.121-.385-.181-.847-.181-1.384s.055-.998.164-1.381c.112-.385.292-.68.54-.885s.578-.308.988-.308c.387 0 .706.103.957.308.253.203.44.497.561.882.123.383.184.844.184 1.384zm-2.584 0c0 .422.027.774.082 1.056.057.283.15.494.28.636.13.139.303.209.52.209s.39-.07.52-.209.223-.35.28-.632c.059-.283.089-.636.089-1.06 0-.419-.028-.77-.086-1.053s-.15-.494-.28-.636c-.13-.144-.304-.215-.523-.215s-.393.072-.523.215c-.128.141-.22.353-.277.636a5.642 5.642 0 0 0-.082 1.053z" />
      </Icon>
    );
  }
);
